import Vue from "vue";
import Router from "vue-router";
import { PATH_HOME } from "@/constants/URL";

// 导入解耦路由
import myOkr from "./myokr/myOkr";
import data from "./data";
import KPI from "./KPI";
import teach from "./teach";
import weekly from "./weekly";
import daily from "./daily";

import newdetail from "./myokr/detail";
import addOkr from "./myokr/addOkr";
import score from "./myokr/score";
import evaluation360 from "./evaluation360";
import e360 from "./e360";
import new360 from "./new360";

import messagelist from "./message";
import friendlyTips from "./friend";
import myorg from "./myOrg";

// 导入登录以及其他 /404  403...
import loginOther from "./loginOther";
import permission from './permission';

Vue.use(Router);

export const routes = [
  { path: "/", redirect: PATH_HOME },
  permission,
  // 我的okr
  myOkr,
  // 数据看板
  data,
  // 我的组织
  myorg,
  //KPI
  KPI,
  // 手册
  ...teach,
  // 写周报
  weekly,
  // 日报
  daily,
  //新详情
  newdetail,
  //新编辑创建
  addOkr,
  // 打分页面
  score,
  // 360测评模块
  ...evaluation360,
  // 360 muse 上传等模块
  e360,
  //360测评
  new360,
  ...friendlyTips,
  ...messagelist,
  // 登录以及其他
  ...loginOther
];
const router = new Router({
  mode: "history",
  base: "/",
  routes
});

export default router;
